import { CONFIRM_MODAL, ConfirmModal } from "./ConfirmModal";
import { RESULT_MODAL, ResultModal } from "./ResultModal";
import { ACTION_MODAL, ActionModal } from "./action-modal";


export const allModals = {
  [ACTION_MODAL]: ActionModal,
  [CONFIRM_MODAL]: ConfirmModal,
  [RESULT_MODAL]: ResultModal
}
